import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/ferncast_logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-329c24d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-jc-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "300",
    alt: "Ferncast logo",
    src: _imports_0
  })
], -1))
const _hoisted_3 = {
  key: 0,
  class: "p-d-flex p-jc-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "p-d-flex p-jc-between p-mt-3" }
const _hoisted_7 = { class: "p-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Login = _resolveComponent("Login")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, "License Server v" + _toDisplayString(_ctx.version), 1)
      ]),
      _hoisted_2
    ]),
    (_ctx.showSpinner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_ProgressSpinner)
        ]))
      : (_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_TabMenu, { model: _ctx.menuItems }, null, 8, ["model"]),
            _createVNode(_component_router_view, {
              isAuthenticated: _ctx.isAuthenticated,
              "onUpdate:isAuthenticated": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isAuthenticated) = $event))
            }, null, 8, ["isAuthenticated"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Login, {
              isAuthenticated: _ctx.isAuthenticated,
              "onUpdate:isAuthenticated": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAuthenticated) = $event))
            }, null, 8, ["isAuthenticated"])
          ])),
    _createVNode(_component_Toast, { position: "bottom-right" }),
    _createVNode(_component_ConfirmDialog),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, " © " + _toDisplayString(_ctx.currentYear) + " Copyright by Ferncast GmbH ", 1),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, { to: "thirdPartyLicenses" }, {
            default: _withCtx(() => [
              _createTextVNode("Third party licenses")
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _ctx.isAuthenticated]
        ])
      ])
    ])
  ], 64))
}